<template>
  <div class="footer-page-container">
    <div class="page-content">
      <h1 class="page-title">企业资质</h1>
      <div class="page-body">
        <section class="qualification-intro">
          <h2>资质认证</h2>
          <p>我们始终坚持合法合规办学，拥有完善的企业资质和专业认证，确保为学员提供高质量的教育培训服务。</p>
        </section>
        
        <section class="qualification-certificates" style="margin-top: 30px;">
          <h2>主要资质证书</h2>
          <div class="certificates-grid">
            <div class="certificate-item">
              <h3>办学许可证</h3>
              <p>编号：1100003000123</p>
              <p>颁发单位：北京市教育委员会</p>
            </div>
            <div class="certificate-item">
              <h3>营业执照</h3>
              <p>统一社会信用代码：91110105XXXXXXXXXX</p>
              <p>颁发单位：北京市工商行政管理局</p>
            </div>
            <div class="certificate-item">
              <h3>ISO9001质量管理体系认证</h3>
              <p>认证范围：教育培训服务</p>
              <p>颁发单位：中国质量认证中心</p>
            </div>
            <div class="certificate-item">
              <h3>企业信用等级证书</h3>
              <p>等级：AAA级</p>
              <p>颁发单位：中国企业信用评价中心</p>
            </div>
          </div>
        </section>
        
        <section class="qualification-honors" style="margin-top: 30px;">
          <h2>荣誉奖项</h2>
          <ul class="honors-list">
            <li>2024年度中国职业教育十大品牌</li>
            <li>2023年度最具影响力教育机构</li>
            <li>2023年度学员满意度最佳教育机构</li>
            <li>2022年度就业服务先进单位</li>
            <li>2022年度诚信办学示范单位</li>
            <li>2021年度教育创新奖</li>
          </ul>
        </section>
        
        <section class="qualification-partners" style="margin-top: 30px;">
          <h2>合作单位</h2>
          <p>我们与众多知名企业、院校和机构建立了长期合作关系，共同推动职业教育的发展。</p>
          <div class="partners-list" style="margin-top: 15px;">
            <h3>合作企业</h3>
            <ul class="partner-items">
              <li>腾讯科技有限公司</li>
              <li>阿里巴巴集团</li>
              <li>百度在线网络技术有限公司</li>
              <li>华为技术有限公司</li>
              <li>京东集团</li>
            </ul>
            
            <h3 style="margin-top: 15px;">合作院校</h3>
            <ul class="partner-items">
              <li>北京大学</li>
              <li>清华大学</li>
              <li>中国人民大学</li>
              <li>北京航空航天大学</li>
              <li>北京理工大学</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyQualification',
  data() {
    return {
      // 页面数据
    }
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped lang="scss">
.footer-page-container {
  max-width: 1200px;
  margin: 100px auto 0;
  padding: 40px 20px;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #3E2CCD;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.page-body {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  
  p {
    margin-bottom: 15px;
  }
}
</style>